import {
  isEnabled,
  isMandatory,
  isAdminForm,
  isBlockEnabled,
} from "@/features/metafields/services";
import {
  getArrayFieldState,
  getArrayFieldInvalid,
  getObjectFieldState,
  getObjectFieldInvalid,
  makeOptions,
  buildLabel,
  makeId,
} from "@/form-utils";

export default {
  inject: {
    metafieldsFormCode: {},
    placement: {
      default: null,
    },
  },
  computed: {
    metaFields() {
      return this.SchoolSettings.metafields;
    },
    isAdminForm() {
      return isAdminForm(this.metafieldsFormCode);
    },
  },
  methods: {
    getField: function (block, field) {
      return this.metaFields[block][field];
    },
    getLabel: function (block, field) {
      return this.getField(block, field).label;
    },
    makeName: function (name) {
      if (this.prefix) {
        return `${this.prefix}-${name}`;
      }
      return name;
    },
    makeId: function (name) {
      return makeId(this.prefix, name);
    },
    /**
     * Make label for input.
     *
     * @param {String} block Meta block name
     * @param {String} field Meta field name
     * @param {Boolean} forceRequired Show/hide required asterix regardless of metafields.
     * This flag is for fields, which are required depend on another fied's value.
     */
    makeLabel: function (block, field, forceRequired) {
      const label = this.getLabel(block, field);
      let required = forceRequired;
      if (required === undefined) {
        required = this.isRequired(block, field);
      }
      return buildLabel(label, required);
    },
    makeDesc: function (block, field) {
      return this.getField(block, field).description;
    },
    getOptions: function (block, field, extraOptions = []) {
      const options = this.getField(block, field).options;
      const uniqueOptions = extraOptions.filter(
        (option) => option && options.indexOf(option) === -1,
      );
      return [...uniqueOptions, ...options];
    },
    makeSelectOptions: function (block, field, extraOptions) {
      return makeOptions(this.getOptions(block, field, extraOptions), "");
    },
    isEnabled: function (block, field) {
      const fieldObject = this.getField(block, field);
      return (
        fieldObject &&
        isEnabled(
          fieldObject.enabled,
          this.metafieldsFormCode,
          fieldObject.placement,
          this.getPlacement(),
        )
      );
    },
    /**
     * Check if any of fields is enabled.
     * @param {String} block Meta fields block
     * @param {Array<String>} fields List of fields
     */
    isFieldsListEnabled: function (block, fields) {
      return fields.some((field) => this.isEnabled(block, field));
    },
    isRequired: function (block, field) {
      const fieldObject = this.getField(block, field);
      return fieldObject && isMandatory(fieldObject.mandatory, this.metafieldsFormCode);
    },
    arrayFieldState: getArrayFieldState,
    arrayFieldInvalid: getArrayFieldInvalid,
    objectFieldState: getObjectFieldState,
    objectFieldInvalid: getObjectFieldInvalid,
    isBlockEnabled: function (block) {
      return isBlockEnabled(
        this.metaFields,
        block,
        this.metafieldsFormCode,
        this.getPlacement(),
      );
    },
    buildLabel: buildLabel,
    getPlacement: function () {
      return this.placement;
    },
    getFieldsForPlacement: function (block, placement) {
      return Object.entries(this.metaFields[block])
        .filter(([field, data]) => field !== "_meta" && data.placement === placement)
        .map(([field]) => field);
    },
  },
};
